import { normalizeKey } from './normalizeDietKey';

// Fixed display order for diet meal types.
export const MEALPERIODS = [
  'Pre-Breakfast',
  'Breakfast',
  'Mid-Morning Snack',
  'Lunch',
  'Snacks',
  'Dinner',
  'Bedtime',
  'Pre-Workout',
  'Post-Workout',
];

// MEALPERIODS plus any other meal type the meals use (e.g. one added in Diet
// Utils, like Brunch), placed by its Utils sequence_number; the fixed periods
// rank 1..9 and win ties. Returns MEALPERIODS itself when there are no extras.
export function mealPeriodsWithExtras(meals, utilsMealTypes = []) {
  const seen = new Set(MEALPERIODS.map((p) => normalizeKey(p)));
  const extras = [];
  (meals || []).forEach((m) => {
    const label = m.meal_type_description || m.meal_type || '';
    const key = normalizeKey(label);
    if (!key || seen.has(key)) return;
    seen.add(key);
    extras.push(label);
  });
  if (extras.length === 0) return MEALPERIODS;

  const rankOf = (label) => {
    const mt = (utilsMealTypes || []).find(
      (t) => normalizeKey(t.description || '') === normalizeKey(label)
    );
    const seq = Number(mt?.sequence_number);
    return Number.isFinite(seq) ? seq : Infinity;
  };
  return [
    ...MEALPERIODS.map((p, i) => ({ p, rank: i + 1 })),
    ...extras.map((p) => ({ p, rank: rankOf(p) })),
  ]
    .sort((a, b) => a.rank - b.rank)
    .map((r) => r.p);
}
